const appInfo = {
    title: 'Vitome Limited',
    doctortitle: "Vito Pro",
    disttitle: "Distributor Portal",
    versionString: "1.0.7"
};
export default appInfo;

